<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  import {initMenu} from "@/utils/menus";
  import router from "@/router";
  import store from "@/store";

  export default {
    created() {

      if(router.currentRoute.path != '/') {
        initMenu(router, store);
      };

      // 浏览器控制按钮前进后退触发函数
      window.addEventListener('popstate', this.popstate, false);
    },

    methods: {

      popstate() {
        const currentPath = this.$router.currentRoute.path;
        const returnPath = this.$router.currentRoute.meta.returnPath;

        if (returnPath) {
          this.$router.push(returnPath);
        } else if (currentPath.startsWith('/app')) {
          this.$router.push('/app/login');
        } else if (currentPath !== '/' && currentPath !== '/index') {
          this.$router.go(-1);
        } else {
          this.$router.push('/');
        }
      }
    }

  }


</script>

<style>

  .is-flex {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  .full-image {
    width: 100%;
    height: 100%;
  }

</style>
